<template>
  <router-link :to="{ name: 'EventForm', query: { teamId: teamId, activityId: activityId } }">
    <div class="add-new-event">
      <el-button type="primary" circle plain>          
        <el-icon><Plus/></el-icon>
      </el-button>
      <span class="add-new-event__label">
        New event
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'AddNewEvent',
  props: {
    teamId: {
      type: Number,
      required: false,
    },
    activityId: {
      type: Number,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.add-new-event {
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  margin-bottom: var(--global-dimension-size-400);

  cursor: pointer;
  padding: 14px 20px;
  box-sizing: border-box;
  color: var(--color-primary-200);
  background-color: var(--color-primary-400);
  border-radius: var(--border-radius-base);

  &:hover {
    background-color: var(--color-primary-500);
  }

  &__label {
    font-weight: 500;
    margin-left: 16px;
    font-size: var(--font-size-300);
  }
}
</style>
